import { ComparisonOperators, FovErrorExperience, FovErrorOption, FovErrorType, FovFieldTypes, FovNodeTypes, FovPageType, HttpMethods, } from '@contentsquare/fov-constants';
// ANY PAGE
/**********API*****************/
// User who visited any page and experienced any API error
const anyAPIErrorOnAnyPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyAPIErrorOnAnyPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            field: 'errorApi:type',
            operator: 'exists',
            value: null,
            nodeType: 'filter',
        },
    },
    nodeType: 'filter',
};
// Users who visited any page and havent experienced any API error
const anyAPIErrorOnAnyPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyAPIErrorOnAnyPageExclude = {
    child: {
        field: 'goal',
        operator: 'equals',
        value: {
            action: 'pageview',
            page: {
                field: 'errorApi:type',
                operator: 'exists',
                value: null,
                nodeType: 'filter',
            },
        },
        nodeType: 'filter',
    },
    nodeType: 'NOT',
};
// User who visited any page and experienced a named API error with requestURL that contains 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement'
const namedAPIErrorOnAnyPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedAPIErrorOnAnyPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            field: 'errorApi:url',
            operator: 'matches_regex',
            value: '(?i)(.*https://www\\.ray-ban\\.com/usa/mobile/prescription-insurance-and-reimbursement.*)',
            nodeType: 'filter',
        },
    },
    nodeType: 'filter',
};
// User who visited any page and havent experienced a named API error with requestURL that contains 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement'
const namedAPIErrorOnAnyPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedAPIErrorOnAnyPageExclude = {
    child: {
        field: 'goal',
        operator: 'equals',
        value: {
            action: 'pageview',
            page: {
                field: 'errorApi:url',
                operator: 'matches_regex',
                value: '(?i)(.*https://www\\.ray-ban\\.com/usa/mobile/prescription-insurance-and-reimbursement.*)',
                nodeType: 'filter',
            },
        },
        nodeType: 'filter',
    },
    nodeType: 'NOT',
};
// User who visited any page and experienced an exact API error with details ...
const exactAPIErrorOnAnyPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
        apiErrorURL: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        apiErrorMethod: HttpMethods.GET,
        apiErrorStatusCode: '401',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactAPIErrorOnAnyPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'errorApi:url',
                    operator: 'equals',
                    value: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
                    nodeType: 'filter',
                },
                {
                    field: 'errorApi:method',
                    operator: 'equals',
                    value: 'GET',
                    nodeType: 'filter',
                },
                {
                    field: 'errorApi:statusCode',
                    operator: 'equals',
                    value: '401',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// User who visited any page and havent experienced an exact API error with details ...
const exactAPIErrorOnAnyPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        apiErrorMethod: HttpMethods.GET,
        apiErrorStatusCode: '401',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactAPIErrorOnAnyPageExclude = {
    child: {
        field: 'goal',
        operator: 'equals',
        value: {
            action: 'pageview',
            page: {
                children: [
                    {
                        field: 'errorApi:url',
                        operator: 'equals',
                        value: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
                        nodeType: 'filter',
                    },
                    {
                        field: 'errorApi:method',
                        operator: 'equals',
                        value: 'GET',
                        nodeType: 'filter',
                    },
                    {
                        field: 'errorApi:statusCode',
                        operator: 'equals',
                        value: '401',
                        nodeType: 'filter',
                    },
                ],
                nodeType: 'AND',
            },
        },
        nodeType: 'filter',
    },
    nodeType: 'NOT',
};
// User who visited any page and experienced a grouped API error 1234
const groupedAPIErrorOnAnyPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedAPIErrorOnAnyPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: { field: 'errorApi:groupId', operator: 'equals', value: '1234', nodeType: 'filter' },
    },
    nodeType: 'filter',
};
// User who visited any page and havent experienced a grouped API error 1234
const groupedAPIErrorOnAnyPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedAPIErrorOnAnyPageExclude = {
    child: {
        field: 'goal',
        operator: 'equals',
        value: {
            action: 'pageview',
            page: {
                field: 'errorApi:groupId',
                operator: 'equals',
                value: '1234',
                nodeType: 'filter',
            },
        },
        nodeType: 'filter',
    },
    nodeType: 'NOT',
};
/******************************************************************** */
// SPECIFIC PAGE
/**********API*****************/
// Users who visited a specific page page1 and experienced any API error
const anyAPIErrorOnSpecificPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyAPIErrorOnSpecificPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'errorApi:type',
                    operator: 'exists',
                    value: null,
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    nodeType: 'filter',
                    operator: 'equals',
                    value: '/page1',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific page page1 and havent experienced any API error
const anyAPIErrorOnSpecificPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: undefined,
        apiErrorMethod: undefined,
        apiErrorStatusCode: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyAPIErrorOnSpecificPageExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                field: 'page:path',
                                operator: 'equals',
                                value: '/page1',
                                nodeType: 'filter',
                            },
                            {
                                field: 'errorApi:type',
                                operator: 'exists',
                                value: null,
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// Users who visited a specific page page1 and experienced a named API error with requestURL that contains 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement'
const namedAPIErrorOnSpecificPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        apiErrorMethod: undefined,
        apiErrorStatusCode: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedAPIErrorOnSpecificPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'errorApi:url',
                    operator: 'matches_regex',
                    value: '(?i)(.*https://www\\.ray-ban\\.com/usa/mobile/prescription-insurance-and-reimbursement.*)',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific page page1 and havn't experienced a named API error with requestURL that contains 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement'
const namedAPIErrorOnSpecificPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        apiErrorMethod: undefined,
        apiErrorStatusCode: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedAPIErrorOnSpecificPageExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                field: 'page:path',
                                operator: 'equals',
                                value: '/page1',
                                nodeType: 'filter',
                            },
                            {
                                field: 'errorApi:url',
                                operator: 'matches_regex',
                                value: '(?i)(.*https://www\\.ray-ban\\.com/usa/mobile/prescription-insurance-and-reimbursement.*)',
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// Users who visited a specific page page1 and experienced an exact API error with details ...
const exactAPIErrorOnSpecificPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        apiErrorMethod: HttpMethods.GET,
        apiErrorStatusCode: '401',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactAPIErrorOnSpecificPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    children: [
                        {
                            field: 'errorApi:url',
                            operator: 'equals',
                            value: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
                            nodeType: 'filter',
                        },
                        {
                            field: 'errorApi:method',
                            operator: 'equals',
                            value: 'GET',
                            nodeType: 'filter',
                        },
                        {
                            field: 'errorApi:statusCode',
                            operator: 'equals',
                            value: '401',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific page page1 and havent experienced an exact JS error with details ...
const exactAPIErrorOnSpecificPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        apiErrorMethod: HttpMethods.GET,
        apiErrorStatusCode: '401',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactAPIErrorOnSpecificPageExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                field: 'page:path',
                                operator: 'equals',
                                value: '/page1',
                                nodeType: 'filter',
                            },
                            {
                                children: [
                                    {
                                        field: 'errorApi:url',
                                        operator: 'equals',
                                        value: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'errorApi:method',
                                        operator: 'equals',
                                        value: 'GET',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'errorApi:statusCode',
                                        operator: 'equals',
                                        value: '401',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// Users who visited a specific page page1 and experienced a grouped API error 1234
const groupedAPIErrorOnSpecificPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedAPIErrorOnSpecificPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            nodeType: 'AND',
            children: [
                { field: 'errorApi:groupId', operator: 'equals', value: '1234', nodeType: 'filter' },
                { field: 'page:path', operator: 'equals', value: '/page1', nodeType: 'filter' },
            ],
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific page page1 and havent experienced a grouped API error 1234
const groupedAPIErrorOnSpecificPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedAPIErrorOnSpecificPageExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                field: 'page:path',
                                operator: 'equals',
                                value: '/page1',
                                nodeType: 'filter',
                            },
                            {
                                field: 'errorApi:groupId',
                                operator: 'equals',
                                value: '1234',
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
/******************************************************************** */
// SPECIFIC URL
/**********API*****************/
// Users who visited a specific URL and experienced any API error
const anyAPIErrorOnSpecificURLInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.URL,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyAPIErrorOnSpecificURLInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'page:host',
                    operator: 'equals',
                    value: 'www.ray-ban.com',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/usa/mobile/prescription-insurance-and-reimbursement',
                    nodeType: 'filter',
                },
                {
                    field: 'page:query',
                    operator: 'equals',
                    value: '',
                    nodeType: 'filter',
                },
                {
                    field: 'errorApi:type',
                    operator: 'exists',
                    value: null,
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific URL and havent experienced any API error
const anyAPIErrorOnSpecificURLExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: undefined,
        apiErrorMethod: undefined,
        apiErrorStatusCode: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyAPIErrorOnSpecificURLExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    children: [
                        {
                            field: 'page:host',
                            operator: 'equals',
                            value: 'www.ray-ban.com',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:path',
                            operator: 'equals',
                            value: '/usa/mobile/prescription-insurance-and-reimbursement',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:query',
                            operator: 'equals',
                            value: '',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                children: [
                                    {
                                        field: 'page:host',
                                        operator: 'equals',
                                        value: 'www.ray-ban.com',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:path',
                                        operator: 'equals',
                                        value: '/usa/mobile/prescription-insurance-and-reimbursement',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:query',
                                        operator: 'equals',
                                        value: '',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                            {
                                field: 'errorApi:type',
                                operator: 'exists',
                                value: null,
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// Users who visited a specific URL and experienced a named API error with requestURL that contains 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement/user'
const namedAPIErrorOnSpecificURLInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement/user',
        apiErrorMethod: undefined,
        apiErrorStatusCode: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedAPIErrorOnSpecificURLInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'page:host',
                    operator: 'equals',
                    value: 'www.ray-ban.com',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/usa/mobile/prescription-insurance-and-reimbursement',
                    nodeType: 'filter',
                },
                {
                    field: 'page:query',
                    operator: 'equals',
                    value: '',
                    nodeType: 'filter',
                },
                {
                    field: 'errorApi:url',
                    operator: 'matches_regex',
                    value: '(?i)(.*https://www\\.ray-ban\\.com/usa/mobile/prescription-insurance-and-reimbursement/user.*)',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific URL and havent experienced a named API error with requestURL that contains 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement/user'
const namedAPIErrorOnSpecificURLExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement/user',
        apiErrorMethod: undefined,
        apiErrorStatusCode: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedAPIErrorOnSpecificURLExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    children: [
                        {
                            field: 'page:host',
                            operator: 'equals',
                            value: 'www.ray-ban.com',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:path',
                            operator: 'equals',
                            value: '/usa/mobile/prescription-insurance-and-reimbursement',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:query',
                            operator: 'equals',
                            value: '',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                children: [
                                    {
                                        field: 'page:host',
                                        operator: 'equals',
                                        value: 'www.ray-ban.com',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:path',
                                        operator: 'equals',
                                        value: '/usa/mobile/prescription-insurance-and-reimbursement',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:query',
                                        operator: 'equals',
                                        value: '',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                            {
                                field: 'errorApi:url',
                                operator: 'matches_regex',
                                value: '(?i)(.*https://www\\.ray-ban\\.com/usa/mobile/prescription-insurance-and-reimbursement/user.*)',
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// User who visited a specific URL and experienced an exact API error with details ...
const exactAPIErrorOnSpecificURLInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.URL,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        apiErrorURL: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement/user',
        apiErrorMethod: HttpMethods.GET,
        apiErrorStatusCode: '401',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactAPIErrorOnSpecificURLInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'page:host',
                    operator: 'equals',
                    value: 'www.ray-ban.com',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/usa/mobile/prescription-insurance-and-reimbursement',
                    nodeType: 'filter',
                },
                {
                    field: 'page:query',
                    operator: 'equals',
                    value: '',
                    nodeType: 'filter',
                },
                {
                    field: 'errorApi:url',
                    operator: 'equals',
                    value: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement/user',
                    nodeType: 'filter',
                },
                {
                    field: 'errorApi:method',
                    operator: 'equals',
                    value: 'GET',
                    nodeType: 'filter',
                },
                {
                    field: 'errorApi:statusCode',
                    operator: 'equals',
                    value: '401',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// User who visited a specific URL and havent experienced an exact API error with details ...
const exactAPIErrorOnSpecificURLExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement/user',
        apiErrorMethod: HttpMethods.GET,
        apiErrorStatusCode: '401',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactAPIErrorOnSpecificURLExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    children: [
                        {
                            field: 'page:host',
                            operator: 'equals',
                            value: 'www.ray-ban.com',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:path',
                            operator: 'equals',
                            value: '/usa/mobile/prescription-insurance-and-reimbursement',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:query',
                            operator: 'equals',
                            value: '',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                children: [
                                    {
                                        field: 'page:host',
                                        operator: 'equals',
                                        value: 'www.ray-ban.com',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:path',
                                        operator: 'equals',
                                        value: '/usa/mobile/prescription-insurance-and-reimbursement',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:query',
                                        operator: 'equals',
                                        value: '',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                            {
                                children: [
                                    {
                                        field: 'errorApi:url',
                                        operator: 'equals',
                                        value: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement/user',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'errorApi:method',
                                        operator: 'equals',
                                        value: 'GET',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'errorApi:statusCode',
                                        operator: 'equals',
                                        value: '401',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// User who visited a specific URL and experienced a grouped API error with groupId 1234
const groupedAPIErrorOnSpecificURLInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedAPIErrorOnSpecificURLInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                { field: 'page:host', operator: 'equals', value: 'www.ray-ban.com', nodeType: 'filter' },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/usa/mobile/prescription-insurance-and-reimbursement',
                    nodeType: 'filter',
                },
                { field: 'page:query', operator: 'equals', value: '', nodeType: 'filter' },
                { field: 'errorApi:groupId', operator: 'equals', value: '1234', nodeType: 'filter' },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// User who visited a specific URL and haven't experienced a grouped API error with groupId 1234
const groupedAPIErrorOnSpecificURLExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.API,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedAPIErrorOnSpecificURLExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    children: [
                        {
                            field: 'page:host',
                            operator: 'equals',
                            value: 'www.ray-ban.com',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:path',
                            operator: 'equals',
                            value: '/usa/mobile/prescription-insurance-and-reimbursement',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:query',
                            operator: 'equals',
                            value: '',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                children: [
                                    {
                                        field: 'page:host',
                                        operator: 'equals',
                                        value: 'www.ray-ban.com',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:path',
                                        operator: 'equals',
                                        value: '/usa/mobile/prescription-insurance-and-reimbursement',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:query',
                                        operator: 'equals',
                                        value: '',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                            {
                                field: 'errorApi:groupId',
                                operator: 'equals',
                                value: '1234',
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
export const fovErrorSamplesAPI = {
    anyAPIErrorOnAnyPageInclude,
    expandedAnyAPIErrorOnAnyPageInclude,
    anyAPIErrorOnAnyPageExclude,
    expandedAnyAPIErrorOnAnyPageExclude,
    namedAPIErrorOnAnyPageInclude,
    expandedNamedAPIErrorOnAnyPageInclude,
    namedAPIErrorOnAnyPageExclude,
    expandedNamedAPIErrorOnAnyPageExclude,
    exactAPIErrorOnAnyPageInclude,
    expandedExactAPIErrorOnAnyPageInclude,
    exactAPIErrorOnAnyPageExclude,
    expandedExactAPIErrorOnAnyPageExclude,
    groupedAPIErrorOnAnyPageInclude,
    expandedGroupedAPIErrorOnAnyPageInclude,
    groupedAPIErrorOnAnyPageExclude,
    expandedGroupedAPIErrorOnAnyPageExclude,
    anyAPIErrorOnSpecificPageInclude,
    expandedAnyAPIErrorOnSpecificPageInclude,
    anyAPIErrorOnSpecificPageExclude,
    expandedAnyAPIErrorOnSpecificPageExclude,
    namedAPIErrorOnSpecificPageInclude,
    expandedNamedAPIErrorOnSpecificPageInclude,
    namedAPIErrorOnSpecificPageExclude,
    expandedNamedAPIErrorOnSpecificPageExclude,
    exactAPIErrorOnSpecificPageInclude,
    expandedExactAPIErrorOnSpecificPageInclude,
    exactAPIErrorOnSpecificPageExclude,
    expandedExactAPIErrorOnSpecificPageExclude,
    groupedAPIErrorOnSpecificPageInclude,
    expandedGroupedAPIErrorOnSpecificPageInclude,
    groupedAPIErrorOnSpecificPageExclude,
    expandedGroupedAPIErrorOnSpecificPageExclude,
    anyAPIErrorOnSpecificURLInclude,
    expandedAnyAPIErrorOnSpecificURLInclude,
    anyAPIErrorOnSpecificURLExclude,
    expandedAnyAPIErrorOnSpecificURLExclude,
    namedAPIErrorOnSpecificURLInclude,
    expandedNamedAPIErrorOnSpecificURLInclude,
    namedAPIErrorOnSpecificURLExclude,
    expandedNamedAPIErrorOnSpecificURLExclude,
    exactAPIErrorOnSpecificURLInclude,
    expandedExactAPIErrorOnSpecificURLInclude,
    exactAPIErrorOnSpecificURLExclude,
    expandedExactAPIErrorOnSpecificURLExclude,
    groupedAPIErrorOnSpecificURLInclude,
    expandedGroupedAPIErrorOnSpecificURLInclude,
    groupedAPIErrorOnSpecificURLExclude,
    expandedGroupedAPIErrorOnSpecificURLExclude,
};
//# sourceMappingURL=fov-error.samples-api.js.map